// import { SiWix } from "react-icons/si";
import { TbBrandGmail } from 'react-icons/tb';
// import { SiShopify } from "react-icons/si";
// import { SiAmazonaws } from "react-icons/si";
import { FaAutoprefixer } from 'react-icons/fa';
// import { FaDatabase } from "react-icons/fa";
// import { SiHtml5 } from "react-icons/si";
import { SiBlender } from 'react-icons/si';
import { FaMonero } from 'react-icons/fa';
import { SiRhinoceros } from 'react-icons/si';
// import { SiAmazon } from 'react-icons/si';
// import { SiDjango } from 'react-icons/si';
import { TbBrandZulip } from 'react-icons/tb';
export const services = [
  {
    iconName: SiRhinoceros,
    title: 'Rhino',
    text: 'Rhino is a powerful 3D modeling software known for its versatility and precision in creating complex designs.',
  },
  {
    iconName: FaMonero,
    title: 'Maya ',
    text: 'Maya is a powerful 3D computer graphics software used for modeling, animation, and rendering.',
  },
  {
    iconName: SiBlender,
    title: 'Blender',
    text: 'Blender is a powerful, open-source 3D creation suite used for modeling, animation, and rendering.',
  },
  {
    iconName: TbBrandZulip,
    title: ' ZBrush',
    text: 'ZBrush is a powerful digital sculpting and painting software, widely used by artists and designers for creating detailed 3D models',
  },
  {
    iconName: TbBrandGmail,
    title: 'MatrixGold',
    text: 'MatrixGold is a leading jewelry design software known for its advanced CAD capabilities and gemstone modeling.',
  },

  {
    iconName: FaAutoprefixer,
    title: 'AutoCAD',
    text: 'AutoCAD is a widely used computer-aided design (CAD) software that empowers professionals to create, edit, and analyze 2D and 3D designs with precision and efficiency.',
  },
  // {
  //   iconName: SiWix,
  //   title: "Sed ut perspiciatis",
  //   text: "Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi",
  // },
  // {
  //   iconName:  SiShopify,
  //   title: "Sed ut perspiciatis",
  //   text: "Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi",
  // },
  // {
  //   iconName: SiHtml5,
  //   title: "Divera don",
  //   text: "Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi",
  // },
  // {
  //   iconName: SiAmazonaws,
  //   title: "Lorem Ipsum",
  //   text: "Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi",
  // },

  // {
  //   iconName: SiDjango ,
  //   title: "Sed ut perspiciatis",
  //   text: "Voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi",
  // },
  ,
];

// Assuming this is Services.js

// import React from 'react';

// // Images
// import rhinoImage from '../../assets/rhino.jpg';
// import mayaImage from '../../assets/maya.jpg';
// import blenderImage from '../../assets/blender.png';
// import zBrushImage from '../../assets/zbrush.png';
// import matrixGoldImage from '../../assets/matrixgold.png';
// import autoCADImage from '../../assets/autocad.png';

// // Data
// export const services = [
//   {
//     imageSrc: rhinoImage,
//     title: 'Rhino',
//     text: 'Rhino is a powerful 3D modeling software known for its versatility and precision in creating complex designs.',
//   },
//   {
//     imageSrc: mayaImage,
//     title: 'Maya ',
//     text: 'Maya is a powerful 3D computer graphics software used for modeling, animation, and rendering.',
//   },
//   {
//     imageSrc: blenderImage,
//     title: 'Blender',
//     text: 'Blender is a powerful, open-source 3D creation suite used for modeling, animation, and rendering.',
//   },
//   {
//     imageSrc: zBrushImage,
//     title: 'ZBrush',
//     text: 'ZBrush is a powerful digital sculpting and painting software, widely used by artists and designers for creating detailed 3D models',
//   },
//   {
//     imageSrc: matrixGoldImage,
//     title: 'MatrixGold',
//     text: 'MatrixGold is a leading jewelry design software known for its advanced CAD capabilities and gemstone modeling.',
//   },
//   {
//     imageSrc: autoCADImage,
//     title: 'AutoCAD',
//     text: 'AutoCAD is a widely used computer-aided design (CAD) software that empowers professionals to create, edit, and analyze 2D and 3D designs with precision and efficiency.',
//   },
// ];

// // // Component
// function ServicesList() {
//   return (
//     <div style={styles.servicesList}>
//       {services.map((service) => (
//         <div key={service.title} style={styles.serviceItem}>
//           <img
//             src={service.imageSrc}
//             alt={service.title}
//             style={styles.serviceImage}
//           />
//           <h2>{service.title}</h2>
//           <p>{service.text}</p>
//         </div>
//       ))}
//     </div>
//   );
// }

// // Styles (changed to an object for inline styles)
// const styles = {
//   servicesList: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     gap: '20px',
//   },
//   serviceItem: {
//     flex: '1 1 200px',
//     border: '1px solid #e0e0e0',
//     padding: '15px',
//     borderRadius: '5px',
//   },
//   serviceImage: {
//     maxWidth: '100%',
//     height: 'auto',
//     marginBottom: '10px',
//   },
// };

// export default ServicesList;
